interface ActionButtonsProps {
  onApprove: () => void;
  onReject: () => void;
}

const ActionButtons = ({ onApprove, onReject }: ActionButtonsProps) => (
  <div className="flex shrink-0 gap-1.5">
    <button
      type="button"
      onClick={e => {
        e.stopPropagation();
        onApprove();
      }}
      className="rounded-md bg-primary px-2.5 py-1 text-[11px] font-medium text-white transition-colors hover:bg-primary/80"
    >
      승인
    </button>
    <button
      type="button"
      onClick={e => {
        e.stopPropagation();
        onReject();
      }}
      className="rounded-md border border-gray-300 bg-white px-2.5 py-1 text-[11px] font-medium text-gray-500 transition-colors hover:border-red-200 hover:bg-red-50 hover:text-red-600"
    >
      반려
    </button>
  </div>
);

export default ActionButtons;
